import {inject, isDevMode} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {DeviceDetectorService} from 'ngx-device-detector';

export const mobileOnlyGuard: CanActivateFn = (route, state) => {
  const deviceService = inject(DeviceDetectorService);
  const router = inject(Router);

  if (!deviceService.isMobile() && !isDevMode()) {
    return router.createUrlTree(['/mobile-only']);
  }

  return true;
};

